"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _ColorCircleBlock = _interopRequireDefault(require("./ColorCircleBlock"));
var _useColorPickerConverter = require("./useColorPickerConverter");
var areColorObjectEqual = function areColorObjectEqual(color1, color2) {
  return (color1 === null || color1 === void 0 ? void 0 : color1.r) === (color2 === null || color2 === void 0 ? void 0 : color2.r) && (color1 === null || color1 === void 0 ? void 0 : color1.g) === (color2 === null || color2 === void 0 ? void 0 : color2.g) && (color1 === null || color1 === void 0 ? void 0 : color1.b) === (color2 === null || color2 === void 0 ? void 0 : color2.b) && (color1 === null || color1 === void 0 ? void 0 : color1.a) === (color2 === null || color2 === void 0 ? void 0 : color2.a);
};
var ColorPickerCircles = function ColorPickerCircles(_ref) {
  var _ref$presetColors = _ref.presetColors,
    presetColors = _ref$presetColors === void 0 ? ['rgba(222, 111, 98, 1)', 'rgba(38, 35, 8, 1)', 'rgba(115, 84, 198, 1)', 'rgba(201, 231, 55, 1)'] : _ref$presetColors,
    onChange = _ref.onChange,
    selectedColor = _ref.selectedColor,
    removeTransparent = _ref.removeTransparent;
  var presetColorsWithTransparent;
  var presetColorsWithoutTransparent = presetColors.filter(function (presetColor) {
    return presetColor !== 'transparent' && presetColor !== 'rgba(0, 0, 0, 0)';
  });
  if (!removeTransparent) {
    // First color in preset is always transparent
    presetColorsWithTransparent = ['rgba(0, 0, 0, 0)'].concat((0, _toConsumableArray2["default"])(presetColorsWithoutTransparent));
  }
  var presetColorsToLowerCase = (presetColorsWithTransparent || presetColorsWithoutTransparent).map(function (color) {
    return color.toLowerCase();
  });

  // Convert hex to rgba format & remove duplicates
  var colorResultPresetColors = (0, _toConsumableArray2["default"])(new Set(presetColorsToLowerCase)).map(function (color) {
    return (0, _useColorPickerConverter.stringToColorResult)(color);
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, colorResultPresetColors.map(function (presetColor) {
    return /*#__PURE__*/_react["default"].createElement(_ColorCircleBlock["default"], {
      key: "".concat(Math.random() * 1000),
      onClick: function onClick() {
        return onChange(presetColor);
      },
      color: presetColor.rgb,
      alpha: presetColor === null || presetColor === void 0 ? void 0 : presetColor.rgb.a,
      isSelected: areColorObjectEqual(presetColor.rgb, selectedColor.rgb)
    });
  }));
};
var _default = exports["default"] = ColorPickerCircles;
//# sourceMappingURL=ColorPickerCircles.js.map